import type { ReactNode } from "react";
import { Icon } from "./icons";

// Toast — codified from 14-diyaloglar.html. A quiet confirmation card with a colored
// left rule, an icon, a title/subtitle, and a dismiss. The loading tone is the solid
// Privé-blue card with a spinner. Presentational + controlled (onClose is the caller's).
export type ToastTone = "success" | "info" | "loading";

export interface ToastProps {
  tone: ToastTone;
  title: ReactNode;
  description?: ReactNode;
  onClose?: () => void;
  closeLabel?: string;
}

export function Toast({ tone, title, description, onClose, closeLabel = "Dismiss" }: ToastProps) {
  return (
    <div className={`k-toast k-toast--${tone}`} role="status">
      {tone === "loading" ? (
        <span className="k-toast__spinner" aria-hidden="true" />
      ) : (
        <span className={`k-toast__icon k-toast__icon--${tone}`}>
          <Icon name={tone === "success" ? "check-circle" : "info"} size={20} strokeWidth={2} />
        </span>
      )}
      <div className="k-toast__body">
        <div className="k-toast__title">{title}</div>
        {description ? <div className="k-toast__sub">{description}</div> : null}
      </div>
      {onClose && tone !== "loading" ? (
        <button type="button" className="k-toast__close" aria-label={closeLabel} onClick={onClose}>
          <Icon name="close" size={16} strokeWidth={2} />
        </button>
      ) : null}
    </div>
  );
}

export function ToastStack({ children }: { children: ReactNode }) {
  return <div className="k-toaststack">{children}</div>;
}
